import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { userDetailBroker } from "../../../redux/user/actions";
import _, { set } from "lodash";
import {
  clickStreamUser,
  goToLPDetailUtil,
  redirectToPageUtil,
  scheduleSessionApiCall,
  SessionKeys,
  showTourAndGuideUtils,
} from "../../../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Loader from "../../../components/Loader/Loader";
import SimplePopup from "../../../components/modal/SimplePopup";
import { useTranslation } from "react-i18next";
const settingsMoney = {
  dots: true,
  arrows: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const MoneyJourney = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [moneyJourney, setMoneyJourney] = useState({});
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [courseData, setCourseData] = useState({});
  const [journeyProgress, setJourneyProgress] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [scrollToShow, setScrollToShow] = useState(3);
  const settingsMoney = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: scrollToShow,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: scrollToShow,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          initialSlide: 0,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    getProfileApi();
  }, [dispatch]);
  const getProfileApi = () => {
    dispatch(
      userDetailBroker({
        module: "getOrderDetailBroker",
        apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        userId: authBroker?.payload?.user?.user_id,
      }),
    );
  };
  useEffect(() => {
    let userDetailResLocal = userDetailRes;
    console.log("userDetailResLocal", userDetailResLocal);
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal?.status === "success") {
        let journey = _.cloneDeep(
          userDetailResLocal?.payload?.payload?.money_journey,
        );
        journey.money_assessment.journey = true;

        let progressArr = [];
        let steps = [
          {
            title: t("take_the_tour"),
            status: journey?.take_a_tour === 1 ? "completed" : "pending",
          },
          {
            title:
              journey?.money_assessment?.cname || "Money Compass assessment",
            status:
              journey?.money_assessment?.status === "completed"
                ? "completed"
                : "pending",
          },
          {
            title: t("schedule_a_coaching_session"),
            status:
              journey?.coach?.status === "completed" ? "completed" : "pending",
          },
          {
            title: t("first_action_path"),
            status:
              journey?.action_path?.status === "completed"
                ? "completed"
                : "pending",
          },
        ];

        steps.sort((a, b) => {
          if (a.status === "completed" && b.status !== "completed") return -1;
          if (a.status !== "completed" && b.status === "completed") return 1;
          return 0;
        });

        const notCompletedCount = steps.filter(
          (step) => step.status !== "completed",
        ).length;
        setScrollToShow(notCompletedCount === 4 ? 3 : notCompletedCount);

        progressArr = steps;
        setJourneyProgress(progressArr);
        setMoneyJourney(journey);
      }
    }
  }, [userDetailRes]);
  const [isOpen, setIsOpen] = useState(false);
  const [showLimitPopup, setShowLimitPopup] = useState(false);

  const toggleAccordion = () => {
    clickStreamUser(
      "toggle_accordin_clicked",
      {
        userId: authBroker?.payload?.user?.user_id,
      },
      authBroker,
    );
    setIsOpen(!isOpen);
  };
  const isMoneyJourneyInProgress = () => {
    return (
      moneyJourney?.take_a_tour === 1 ||
      moneyJourney?.money_assessment?.status === "completed" ||
      moneyJourney?.coach?.status === "completed" ||
      moneyJourney?.action_path?.status === "completed"
    );
  };
  const isMoneyJourneyAllCompleted = () => {
    return (
      moneyJourney?.take_a_tour === 1 &&
      moneyJourney?.money_assessment?.status === "completed" &&
      moneyJourney?.coach?.status === "completed" &&
      moneyJourney?.action_path?.status === "completed"
    );
  };

  const callScheduleApi = () => {
    scheduleSessionApiCall();
  };

  return (
    <>
      <Loader start={isLoading} />
      {isMoneyJourneyAllCompleted() ? (
        <></>
      ) : (
        <>
          <section
            id="moneyJourneyProgress"
            aria-labelledby="money-journey-heading"
            class="money-journey-section mt-2rem mb-3"
          >
            <div className="d-flex gap-3">
              <div className="totls">
                <h2 id="money-journey-heading" class="mb-1 title-money-journey">
                  {isMoneyJourneyInProgress()
                    ? t("money_journey_initiated")
                    : t("get_started_on_your_money_journey")}
                </h2>
                <p class="subhead-tile">
                  {t(
                    "start_your_journey_to_get_personalized_recommendations_and_financial_coaching",
                  )}
                </p>
              </div>
              <div className="iocn">
                <span
                  className={`arrow cursor-pointer ${isOpen ? "open" : ""}`}
                  onClick={toggleAccordion}
                  tabIndex={0}
                  aria-label="Dropdown"
                >
                  <svg
                    width="24"
                    height={isOpen ? "14" : "24"}
                    viewBox={isOpen ? "0 0 24 14" : "0 0 24 24"}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d={
                        isOpen
                          ? "M22.728 0.688168L12 11.4162L1.272 0.688168C1.128 0.544168 0.952 0.472168 0.744 0.472168C0.536 0.472168 0.36 0.544168 0.216 0.688168C0.072 0.832168 0 1.00817 0 1.21617C0 1.42417 0.072 1.60017 0.216 1.74417L12 13.5282L23.784 1.74417C23.928 1.60017 24 1.42417 24 1.21617C24 1.00817 23.928 0.832168 23.784 0.688168C23.64 0.544168 23.464 0.472168 23.256 0.472168C23.048 0.472168 22.872 0.544168 22.728 0.688168Z"
                          : "M22.728 18.3122L12 7.58417L1.272 18.3122C1.128 18.4562 0.952 18.5282 0.744 18.5282C0.536 18.5282 0.36 18.4562 0.216 18.3122C0.072 18.1682 0 17.9922 0 17.7842C0 17.5762 0.072 17.4002 0.216 17.2562L12 5.47217L23.784 17.2562C23.928 17.4002 24 17.5762 24 17.7842C24 17.9922 23.928 18.1682 23.784 18.3122C23.64 18.4562 23.464 18.5282 23.256 18.5282C23.048 18.5282 22.872 18.4562 22.728 18.3122Z"
                      }
                      fill="#474747"
                    />
                  </svg>
                </span>
              </div>
            </div>

            <div
              class="progress-bar-steps"
              role="progressbar"
              aria-valuenow="1"
              aria-valuemin="0"
              aria-valuemax="4"
              aria-label="Money Journey Progress"
            >
              {journeyProgress.map((step, index) => {
                return (
                  <OverlayTrigger
                    key="top"
                    placement="top"
                    //show={true}
                    overlay={
                      isMoneyJourneyInProgress() ? (
                        <Tooltip id={`tooltip-top`}>
                          <>
                            {isMoneyJourneyInProgress()
                              ? journeyProgress?.length > 0 && (
                                  <div
                                    style={{
                                      color: "white",
                                      backgroundColor: "transparent",
                                    }}
                                  >
                                    <div className="text-start p-0 mb-1">
                                      {t("steps_completed")}
                                    </div>
                                    <ul className="text-start">
                                      {journeyProgress.map((step, index) => {
                                        return step?.status === "completed" ? (
                                          <li>{step?.title}</li>
                                        ) : (
                                          ""
                                        );
                                      })}
                                    </ul>
                                  </div>
                                )
                              : ""}
                          </>
                        </Tooltip>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <div
                      key={index}
                      tabIndex={0}
                      aria-lable={step?.title}
                      className={`progress-step ${step.status}`}
                    ></div>
                  </OverlayTrigger>
                );
              })}
            </div>
          </section>

          <section
            id="momentumTracker"
            tabIndex={0}
            aria-labelledby="money-journey-heading"
            className={`money-journey-section-slider mb-2rem ${isOpen ? "" : "open"} mb-3`}
          >
            <Slider {...settingsMoney} className="slider-gap">
              {[
                moneyJourney?.take_a_tour === 0 && (
                  <div
                    className="card-money cursor-pointer"
                    key="tour"
                    tabIndex={0}
                    aria-label="Take the tour. Learn where everything is so you can start digging into the content."
                    onClick={() => {
                      clickStreamUser(
                        "take_a_tour_clicked",
                        {
                          userId: authBroker?.payload?.user?.user_id,
                        },
                        authBroker,
                      );
                      showTourAndGuideUtils(dispatch);
                    }}
                  >
                    <div class="d-flex align-items-center justify-content-between gap-10 titlt-headmoney">
                      <div className="icon-left">
                        <span className="money-journey">
                          <svg
                            width="30"
                            height="26"
                            viewBox="0 0 30 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M30 25.2916V3.52492L19.5458 0.708252L19.5208 0.795752C19.5208 0.795752 19.5083 0.795752 19.5 0.791585C19.3292 0.737419 19.1375 0.737419 18.95 0.791585L10.675 3.33742L1.1875 0.783252C0.904167 0.708252 0.604167 0.766585 0.370833 0.945752C0.1375 1.12492 0 1.39992 0 1.69575V21.5083C0 21.9374 0.2875 22.3083 0.695833 22.4208L10.4167 25.0374L10.4458 25.0458C10.525 25.0666 10.6083 25.0791 10.6917 25.0791C10.7833 25.0791 10.8792 25.0666 10.9667 25.0374L19.3125 22.4666C19.3625 22.4666 19.4125 22.4583 19.4583 22.4499L29.9917 25.2874L30 25.2916ZM11.5542 5.04575L18.3708 2.94575V20.7833L11.5542 22.8833V5.04575ZM28.1125 22.8249L20.2583 20.7083V2.85825L28.1125 4.97492V22.8291V22.8249ZM1.88333 2.92909L9.67083 5.02492V22.8791L1.88333 20.7833V2.92909Z"
                              fill="#474747"
                            />
                          </svg>
                        </span>
                        <h3 className="card-money-title ps-0 mb-0">
                          {t("take_the_tour")}
                        </h3>
                      </div>
                      <div class="linkicon" tabIndex={0}>
                        <svg
                          width="32"
                          height="48"
                          viewBox="0 0 32 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.008 21H24V27.672C24 28.0347 23.872 28.344 23.616 28.6C23.36 28.8667 23.0453 29 22.672 29H9.328C8.96533 29 8.65067 28.8667 8.384 28.6C8.128 28.344 8 28.0347 8 27.672V14.328C8 13.9547 8.128 13.64 8.384 13.384C8.65067 13.128 8.96533 13 9.328 13H16V13.992H9.328C9.24267 13.992 9.168 14.0293 9.104 14.104C9.04 14.168 9.008 14.2427 9.008 14.328V27.672C9.008 27.7573 9.04 27.832 9.104 27.896C9.168 27.9707 9.24267 28.008 9.328 28.008H22.672C22.7573 28.008 22.832 27.9707 22.896 27.896C22.9707 27.832 23.008 27.7573 23.008 27.672V21ZM14.704 22.968L14 22.28L22.304 13.992H18.656C18.5173 13.992 18.4 13.944 18.304 13.848C18.208 13.752 18.16 13.6347 18.16 13.496C18.16 13.3573 18.208 13.24 18.304 13.144C18.4 13.048 18.5173 13 18.656 13H23.984V18.328C23.984 18.4667 23.936 18.584 23.84 18.68C23.744 18.776 23.6267 18.824 23.488 18.824C23.3493 18.824 23.232 18.776 23.136 18.68C23.04 18.584 22.992 18.4667 22.992 18.328V14.68L14.704 22.968Z"
                            fill="#415385"
                          />
                        </svg>
                      </div>
                    </div>
                    <p className="small-text-money">
                      {t("get_started_with_a_quick_walkthrough")}
                    </p>
                  </div>
                ),
                moneyJourney?.money_assessment?.status !== "completed" && (
                  <div
                    className="card-money cursor-pointer"
                    key="assessment"
                    tabIndex={0}
                    aria-label="Take the tour. Learn where everything is so you can start digging into the content."
                    onClick={() => {
                      clickStreamUser(
                        "complete_your_money_compass_assessment_clicked",
                        {
                          userId: authBroker?.payload?.user?.user_id,
                        },
                        authBroker,
                      );
                      redirectToPageUtil(
                        moneyJourney?.money_assessment,
                        navigate,
                        authBroker,
                        setCourseData,
                        dispatch,
                        "course",
                      );
                    }}
                  >
                    <div class="d-flex align-items-center justify-content-between gap-10 titlt-headmoney">
                      <div className="icon-left">
                        <span className="money-journey">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.03 30C17.07 30 19.02 29.6 20.88 28.8C22.68 28.04 24.27 26.96 25.65 25.56C27.03 24.18 28.09 22.6 28.83 20.82C29.61 18.96 30 17.01 30 14.97C30 12.93 29.6 10.98 28.8 9.12C28.04 7.32 26.96 5.73 25.56 4.35C24.18 2.97 22.6 1.91 20.82 1.17C18.96 0.39 17.01 0 14.97 0C12.93 0 10.98 0.4 9.12 1.2C7.34 1.96 5.75 3.04 4.35 4.44C2.97 5.82 1.91 7.4 1.17 9.18C0.39 11.04 0 12.98 0 15C0 17.02 0.38 18.95 1.14 20.79C1.9 22.61 2.99 24.22 4.41 25.62C5.83 27.04 7.46 28.12 9.3 28.86C11.14 29.62 13.05 30 15.03 30ZM14.97 1.86C17.35 1.86 19.56 2.46 21.6 3.66C23.58 4.8 25.15 6.36 26.31 8.34C27.53 10.38 28.14 12.59 28.14 14.97C28.14 17.35 27.54 19.56 26.34 21.6C25.2 23.58 23.64 25.15 21.66 26.31C19.62 27.53 17.41 28.14 15.03 28.14C12.65 28.14 10.44 27.54 8.4 26.34C6.42 25.2 4.85 23.64 3.69 21.66C2.49 19.62 1.89 17.41 1.89 15.03C1.89 12.65 2.48 10.44 3.66 8.4C4.8 6.42 6.36 4.85 8.34 3.69C10.38 2.47 12.59 1.86 14.97 1.86ZM18.84 15C18.2 14.42 17.19 13.98 15.81 13.68V10.77C16.11 10.79 16.38 10.92 16.62 11.16C16.9 11.5 17.04 11.88 17.04 12.3H19.38C19.36 11.84 19.26 11.41 19.08 11.01C18.9 10.59 18.65 10.22 18.33 9.9C17.65 9.28 16.82 8.92 15.84 8.82V7.5H14.49V8.85C14.01 8.89 13.55 9 13.11 9.18C12.67 9.36 12.28 9.61 11.94 9.93C11.6 10.23 11.34 10.59 11.16 11.01C10.98 11.43 10.89 11.87 10.89 12.33C10.89 12.91 11.02 13.43 11.28 13.89C11.52 14.29 11.85 14.61 12.27 14.85C12.59 15.03 12.9 15.18 13.2 15.3C13.32 15.34 13.64 15.44 14.16 15.6L14.49 15.69V19.11C14.07 19.03 13.72 18.81 13.44 18.45C13.1 18.03 12.94 17.57 12.96 17.07V17.04H10.62C10.64 17.6 10.76 18.13 10.98 18.63C11.2 19.13 11.5 19.58 11.88 19.98C12.62 20.66 13.5 21.03 14.52 21.09V22.5H15.84V21.09C16.52 21.07 17.2 20.88 17.88 20.52C18.48 20.22 18.96 19.78 19.32 19.2C19.64 18.68 19.8 18.14 19.8 17.58C19.82 17.1 19.75 16.64 19.59 16.2C19.43 15.74 19.18 15.34 18.84 15ZM13.59 12.93C13.35 12.71 13.23 12.43 13.23 12.09C13.23 11.67 13.37 11.34 13.65 11.1C13.89 10.9 14.17 10.78 14.49 10.74V13.35C14.19 13.27 13.89 13.13 13.59 12.93ZM16.95 18.66C16.65 18.94 16.28 19.11 15.84 19.17V16.05C16.32 16.17 16.72 16.36 17.04 16.62C17.36 16.88 17.5 17.2 17.46 17.58C17.48 18 17.31 18.36 16.95 18.66Z"
                              fill="#474747"
                            />
                          </svg>
                        </span>
                        <h3 className="card-money-title ps-0 mb-0">
                          {t("complete_your_money_compass_assessment")}
                        </h3>
                      </div>
                      <div class="linkicon" tabIndex={0}>
                        <svg
                          width="32"
                          height="48"
                          viewBox="0 0 32 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.008 21H24V27.672C24 28.0347 23.872 28.344 23.616 28.6C23.36 28.8667 23.0453 29 22.672 29H9.328C8.96533 29 8.65067 28.8667 8.384 28.6C8.128 28.344 8 28.0347 8 27.672V14.328C8 13.9547 8.128 13.64 8.384 13.384C8.65067 13.128 8.96533 13 9.328 13H16V13.992H9.328C9.24267 13.992 9.168 14.0293 9.104 14.104C9.04 14.168 9.008 14.2427 9.008 14.328V27.672C9.008 27.7573 9.04 27.832 9.104 27.896C9.168 27.9707 9.24267 28.008 9.328 28.008H22.672C22.7573 28.008 22.832 27.9707 22.896 27.896C22.9707 27.832 23.008 27.7573 23.008 27.672V21ZM14.704 22.968L14 22.28L22.304 13.992H18.656C18.5173 13.992 18.4 13.944 18.304 13.848C18.208 13.752 18.16 13.6347 18.16 13.496C18.16 13.3573 18.208 13.24 18.304 13.144C18.4 13.048 18.5173 13 18.656 13H23.984V18.328C23.984 18.4667 23.936 18.584 23.84 18.68C23.744 18.776 23.6267 18.824 23.488 18.824C23.3493 18.824 23.232 18.776 23.136 18.68C23.04 18.584 22.992 18.4667 22.992 18.328V14.68L14.704 22.968Z"
                            fill="#415385"
                          />
                        </svg>
                      </div>
                    </div>
                    <p className="small-text-money">
                      {t(
                        "get_action_paths_and_coaching_tips_tailored_to_your_goals",
                      )}
                    </p>
                  </div>
                ),
                moneyJourney?.coach?.status !== "completed" && (
                  <div
                    className="card-money cursor-pointer"
                    key="coach"
                    tabIndex={0}
                    aria-label="Take the tour. Learn where everything is so you can start digging into the content."
                    onClick={() => {
                      clickStreamUser(
                        "schedule_a_coaching_session_clicked",
                        {
                          userId: authBroker?.payload?.user?.user_id,
                        },
                        authBroker,
                      );
                      callScheduleApi();
                      window.open(moneyJourney?.coach?.coach_url, "_blank");
                    }}
                  >
                    <div class="d-flex align-items-center justify-content-between gap-10 titlt-headmoney">
                      <div className="icon-left">
                        <span className="money-journey">
                          <svg
                            width="30"
                            height="48"
                            viewBox="0 0 30 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 25.5C13.5 25.5 12.12 25.13 10.86 24.39C9.60001 23.63 8.60001 22.62 7.86 21.36C7.12001 20.1 6.75 18.73 6.75 17.25C6.75 15.75 7.12001 14.37 7.86 13.11C8.60001 11.85 9.60001 10.85 10.86 10.11C12.12 9.37 13.5 9 15 9C16.5 9 17.88 9.37 19.14 10.11C20.4 10.85 21.4 11.85 22.14 13.11C22.88 14.37 23.25 15.75 23.25 17.25C23.25 18.75 22.88 20.13 22.14 21.39C21.4 22.65 20.4 23.65 19.14 24.39C17.88 25.13 16.5 25.5 15 25.5ZM15 10.83C13.84 10.83 12.77 11.12 11.79 11.7C10.81 12.28 10.03 13.06 9.45001 14.04C8.89001 15.02 8.61001 16.09 8.61001 17.25C8.61001 18.41 8.89001 19.48 9.45001 20.46C10.03 21.44 10.81 22.22 11.79 22.8C12.77 23.36 13.84 23.64 15 23.64C16.16 23.64 17.23 23.36 18.21 22.8C19.19 22.22 19.96 21.44 20.52 20.46C21.1 19.48 21.39 18.41 21.39 17.25C21.39 16.09 21.1 15.02 20.52 14.04C19.96 13.06 19.19 12.28 18.21 11.7C17.23 11.12 16.16 10.83 15 10.83ZM27.3 29.16C27.46 29.24 27.59 29.36 27.69 29.52C27.81 29.66 27.87 29.82 27.87 30V38.07C27.87 38.33 27.78 38.55 27.6 38.73C27.42 38.91 27.2 39 26.94 39H3.06C2.8 39 2.58 38.91 2.4 38.73C2.22 38.55 2.13 38.33 2.13 38.07V30C2.13 29.82 2.18 29.66 2.28 29.52C2.38 29.36 2.52 29.24 2.7 29.16C5.08 28.12 7.74001 27.41 10.68 27.03C13.56 26.67 16.44 26.67 19.32 27.03C22.26 27.41 24.92 28.12 27.3 29.16ZM15 30.9L14.04 34.17L14.94 35.1L15.96 34.14L15 30.9ZM26.01 37.17V30.63C23.37 29.59 20.62 28.96 17.76 28.74L16.14 29.28L17.97 34.26C18.05 34.48 18.04 34.7 17.94 34.92C17.86 35.14 17.72 35.3 17.52 35.4L14.88 37.38L12.42 35.37C12.22 35.27 12.08 35.11 12 34.89C11.94 34.69 11.95 34.48 12.03 34.26L13.86 29.28L12.24 28.74C9.38 28.96 6.63 29.59 3.99 30.63V37.17H26.01Z"
                              fill="#474747"
                            />
                          </svg>
                        </span>
                        <h3 className="card-money-title ps-0 mb-0">
                          {t("schedule_a_coaching_session")}
                        </h3>
                      </div>
                      <div class="linkicon" tabIndex={0}>
                        <svg
                          width="32"
                          height="48"
                          viewBox="0 0 32 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.008 21H24V27.672C24 28.0347 23.872 28.344 23.616 28.6C23.36 28.8667 23.0453 29 22.672 29H9.328C8.96533 29 8.65067 28.8667 8.384 28.6C8.128 28.344 8 28.0347 8 27.672V14.328C8 13.9547 8.128 13.64 8.384 13.384C8.65067 13.128 8.96533 13 9.328 13H16V13.992H9.328C9.24267 13.992 9.168 14.0293 9.104 14.104C9.04 14.168 9.008 14.2427 9.008 14.328V27.672C9.008 27.7573 9.04 27.832 9.104 27.896C9.168 27.9707 9.24267 28.008 9.328 28.008H22.672C22.7573 28.008 22.832 27.9707 22.896 27.896C22.9707 27.832 23.008 27.7573 23.008 27.672V21ZM14.704 22.968L14 22.28L22.304 13.992H18.656C18.5173 13.992 18.4 13.944 18.304 13.848C18.208 13.752 18.16 13.6347 18.16 13.496C18.16 13.3573 18.208 13.24 18.304 13.144C18.4 13.048 18.5173 13 18.656 13H23.984V18.328C23.984 18.4667 23.936 18.584 23.84 18.68C23.744 18.776 23.6267 18.824 23.488 18.824C23.3493 18.824 23.232 18.776 23.136 18.68C23.04 18.584 22.992 18.4667 22.992 18.328V14.68L14.704 22.968Z"
                            fill="#415385"
                          />
                        </svg>
                      </div>
                    </div>
                    <p className="small-text-money">
                      {t(
                        "get_financial_coaching_and_ignite_your_path_to_financial_wellness",
                      )}
                    </p>
                  </div>
                ),
                moneyJourney?.action_path?.status !== "completed" && (
                  <div
                    className="card-money cursor-pointer"
                    key="action"
                    tabIndex={0}
                    aria-label="Take the tour. Learn where everything is so you can start digging into the content."
                    onClick={() => {
                      clickStreamUser(
                        "complete_the_first_action_path_clicked",
                        {
                          userId: authBroker?.payload?.user?.user_id,
                        },
                        authBroker,
                      );
                      goToLPDetailUtil(moneyJourney?.action_path, navigate, 1);
                    }}
                  >
                    <div class="d-flex align-items-center justify-content-between gap-10 titlt-headmoney">
                      <div className="icon-left">
                        <span className="money-journey">
                          <svg
                            width="30"
                            height="48"
                            viewBox="0 0 30 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.91005 10.95L8.94005 10.92C9.18005 10.92 9.38005 10.84 9.54005 10.68C9.66005 10.56 9.74005 10.41 9.78005 10.23C9.82005 10.05 9.80005 9.89 9.72005 9.75C9.66005 9.59 9.55005 9.46 9.39005 9.36C9.25005 9.26 9.10005 9.21 8.94005 9.21L2.61005 9.15L2.55005 15.66C2.55005 15.9 2.63005 16.11 2.79005 16.29C2.97005 16.45 3.18005 16.53 3.42005 16.53C3.66005 16.53 3.86005 16.45 4.02005 16.29C4.20005 16.11 4.29005 15.9 4.29005 15.66L4.38005 12.09L13.59 21.27L14.34 22.08V39H16.23V21.3L5.91005 10.95ZM27.3901 9L21.09 9.03C20.85 9.03 20.64 9.12 20.46 9.3C20.3 9.46 20.21 9.66 20.19 9.9C20.17 10.14 20.26 10.34 20.46 10.5C20.62 10.68 20.82 10.77 21.06 10.77L24.0901 10.8L16.62 18.24L17.97 19.56L25.59 11.91L25.71 15.51C25.71 15.75 25.8 15.96 25.98 16.14C26.16 16.3 26.3601 16.38 26.58 16.38C26.84 16.38 27.05 16.3 27.21 16.14C27.3701 15.96 27.4501 15.75 27.4501 15.51L27.3901 9Z"
                              fill="#474747"
                            />
                          </svg>
                        </span>
                        <h3 className="card-money-title ps-0 mb-0">
                          {t("complete_the_first_action_path")}
                        </h3>
                      </div>
                      <div class="linkicon" tabIndex={0}>
                        <svg
                          width="32"
                          height="48"
                          viewBox="0 0 32 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.008 21H24V27.672C24 28.0347 23.872 28.344 23.616 28.6C23.36 28.8667 23.0453 29 22.672 29H9.328C8.96533 29 8.65067 28.8667 8.384 28.6C8.128 28.344 8 28.0347 8 27.672V14.328C8 13.9547 8.128 13.64 8.384 13.384C8.65067 13.128 8.96533 13 9.328 13H16V13.992H9.328C9.24267 13.992 9.168 14.0293 9.104 14.104C9.04 14.168 9.008 14.2427 9.008 14.328V27.672C9.008 27.7573 9.04 27.832 9.104 27.896C9.168 27.9707 9.24267 28.008 9.328 28.008H22.672C22.7573 28.008 22.832 27.9707 22.896 27.896C22.9707 27.832 23.008 27.7573 23.008 27.672V21ZM14.704 22.968L14 22.28L22.304 13.992H18.656C18.5173 13.992 18.4 13.944 18.304 13.848C18.208 13.752 18.16 13.6347 18.16 13.496C18.16 13.3573 18.208 13.24 18.304 13.144C18.4 13.048 18.5173 13 18.656 13H23.984V18.328C23.984 18.4667 23.936 18.584 23.84 18.68C23.744 18.776 23.6267 18.824 23.488 18.824C23.3493 18.824 23.232 18.776 23.136 18.68C23.04 18.584 22.992 18.4667 22.992 18.328V14.68L14.704 22.968Z"
                            fill="#415385"
                          />
                        </svg>
                      </div>
                    </div>
                    <p className="small-text-money">
                      {t(
                        "kick_off_your_first_action_path_and_ignite_your_journey_to_financial_wellness",
                      )}
                    </p>
                  </div>
                ),
              ].filter(Boolean)}
              {/* {!_.isEmpty(moneyJourney) && moneyJourney?.take_a_tour === 0 && <div className="card-money cursor-pointer" tabIndex="0" aria-label="Take the tour. Learn where everything is so you can start digging into the content." onClick={() => { showTourAndGuideUtils(dispatch) }}>
            <div class="d-flex align-items-center justify-content-between gap-10 titlt-headmoney">
              <div className="icon-left">
                <span className='money-journey'>
                   <svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M30 25.2916V3.52492L19.5458 0.708252L19.5208 0.795752C19.5208 0.795752 19.5083 0.795752 19.5 0.791585C19.3292 0.737419 19.1375 0.737419 18.95 0.791585L10.675 3.33742L1.1875 0.783252C0.904167 0.708252 0.604167 0.766585 0.370833 0.945752C0.1375 1.12492 0 1.39992 0 1.69575V21.5083C0 21.9374 0.2875 22.3083 0.695833 22.4208L10.4167 25.0374L10.4458 25.0458C10.525 25.0666 10.6083 25.0791 10.6917 25.0791C10.7833 25.0791 10.8792 25.0666 10.9667 25.0374L19.3125 22.4666C19.3625 22.4666 19.4125 22.4583 19.4583 22.4499L29.9917 25.2874L30 25.2916ZM11.5542 5.04575L18.3708 2.94575V20.7833L11.5542 22.8833V5.04575ZM28.1125 22.8249L20.2583 20.7083V2.85825L28.1125 4.97492V22.8291V22.8249ZM1.88333 2.92909L9.67083 5.02492V22.8791L1.88333 20.7833V2.92909Z" fill="#474747" />
                </svg>
                </span>
                <h3 className="card-money-title ps-0 mb-0">Take the tour</h3>
              </div>
              <div class="linkicon">
                <svg width="32" height="48" viewBox="0 0 32 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.008 21H24V27.672C24 28.0347 23.872 28.344 23.616 28.6C23.36 28.8667 23.0453 29 22.672 29H9.328C8.96533 29 8.65067 28.8667 8.384 28.6C8.128 28.344 8 28.0347 8 27.672V14.328C8 13.9547 8.128 13.64 8.384 13.384C8.65067 13.128 8.96533 13 9.328 13H16V13.992H9.328C9.24267 13.992 9.168 14.0293 9.104 14.104C9.04 14.168 9.008 14.2427 9.008 14.328V27.672C9.008 27.7573 9.04 27.832 9.104 27.896C9.168 27.9707 9.24267 28.008 9.328 28.008H22.672C22.7573 28.008 22.832 27.9707 22.896 27.896C22.9707 27.832 23.008 27.7573 23.008 27.672V21ZM14.704 22.968L14 22.28L22.304 13.992H18.656C18.5173 13.992 18.4 13.944 18.304 13.848C18.208 13.752 18.16 13.6347 18.16 13.496C18.16 13.3573 18.208 13.24 18.304 13.144C18.4 13.048 18.5173 13 18.656 13H23.984V18.328C23.984 18.4667 23.936 18.584 23.84 18.68C23.744 18.776 23.6267 18.824 23.488 18.824C23.3493 18.824 23.232 18.776 23.136 18.68C23.04 18.584 22.992 18.4667 22.992 18.328V14.68L14.704 22.968Z" fill="#415385" />
                </svg>
              </div>
            </div>
            <p className="small-text-money">Get started with a quick walkthrough</p>
          </div>}
          {!_.isEmpty(moneyJourney) && moneyJourney?.money_assessment?.status !== "completed" && <div className="card-money" tabIndex="0" aria-label="Take the tour. Learn where everything is so you can start digging into the content.">
             <div class="d-flex align-items-center justify-content-between gap-10 titlt-headmoney">
              <div className="icon-left">
                <span className='money-journey'>
                   <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.03 30C17.07 30 19.02 29.6 20.88 28.8C22.68 28.04 24.27 26.96 25.65 25.56C27.03 24.18 28.09 22.6 28.83 20.82C29.61 18.96 30 17.01 30 14.97C30 12.93 29.6 10.98 28.8 9.12C28.04 7.32 26.96 5.73 25.56 4.35C24.18 2.97 22.6 1.91 20.82 1.17C18.96 0.39 17.01 0 14.97 0C12.93 0 10.98 0.4 9.12 1.2C7.34 1.96 5.75 3.04 4.35 4.44C2.97 5.82 1.91 7.4 1.17 9.18C0.39 11.04 0 12.98 0 15C0 17.02 0.38 18.95 1.14 20.79C1.9 22.61 2.99 24.22 4.41 25.62C5.83 27.04 7.46 28.12 9.3 28.86C11.14 29.62 13.05 30 15.03 30ZM14.97 1.86C17.35 1.86 19.56 2.46 21.6 3.66C23.58 4.8 25.15 6.36 26.31 8.34C27.53 10.38 28.14 12.59 28.14 14.97C28.14 17.35 27.54 19.56 26.34 21.6C25.2 23.58 23.64 25.15 21.66 26.31C19.62 27.53 17.41 28.14 15.03 28.14C12.65 28.14 10.44 27.54 8.4 26.34C6.42 25.2 4.85 23.64 3.69 21.66C2.49 19.62 1.89 17.41 1.89 15.03C1.89 12.65 2.48 10.44 3.66 8.4C4.8 6.42 6.36 4.85 8.34 3.69C10.38 2.47 12.59 1.86 14.97 1.86ZM18.84 15C18.2 14.42 17.19 13.98 15.81 13.68V10.77C16.11 10.79 16.38 10.92 16.62 11.16C16.9 11.5 17.04 11.88 17.04 12.3H19.38C19.36 11.84 19.26 11.41 19.08 11.01C18.9 10.59 18.65 10.22 18.33 9.9C17.65 9.28 16.82 8.92 15.84 8.82V7.5H14.49V8.85C14.01 8.89 13.55 9 13.11 9.18C12.67 9.36 12.28 9.61 11.94 9.93C11.6 10.23 11.34 10.59 11.16 11.01C10.98 11.43 10.89 11.87 10.89 12.33C10.89 12.91 11.02 13.43 11.28 13.89C11.52 14.29 11.85 14.61 12.27 14.85C12.59 15.03 12.9 15.18 13.2 15.3C13.32 15.34 13.64 15.44 14.16 15.6L14.49 15.69V19.11C14.07 19.03 13.72 18.81 13.44 18.45C13.1 18.03 12.94 17.57 12.96 17.07V17.04H10.62C10.64 17.6 10.76 18.13 10.98 18.63C11.2 19.13 11.5 19.58 11.88 19.98C12.62 20.66 13.5 21.03 14.52 21.09V22.5H15.84V21.09C16.52 21.07 17.2 20.88 17.88 20.52C18.48 20.22 18.96 19.78 19.32 19.2C19.64 18.68 19.8 18.14 19.8 17.58C19.82 17.1 19.75 16.64 19.59 16.2C19.43 15.74 19.18 15.34 18.84 15ZM13.59 12.93C13.35 12.71 13.23 12.43 13.23 12.09C13.23 11.67 13.37 11.34 13.65 11.1C13.89 10.9 14.17 10.78 14.49 10.74V13.35C14.19 13.27 13.89 13.13 13.59 12.93ZM16.95 18.66C16.65 18.94 16.28 19.11 15.84 19.17V16.05C16.32 16.17 16.72 16.36 17.04 16.62C17.36 16.88 17.5 17.2 17.46 17.58C17.48 18 17.31 18.36 16.95 18.66Z" fill="#474747" />
                </svg>
                </span>
                <h3 className="card-money-title ps-0 mb-0">Complete your Money Compass assessment</h3>
              </div>
              <div class="linkicon" onClick={() => {
                redirectToPageUtil(
                  moneyJourney?.money_assessment,
                  navigate,
                  authBroker,
                  setCourseData,
                  dispatch,
                  "course"
                )
              }}>
                <svg width="32" height="48" viewBox="0 0 32 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.008 21H24V27.672C24 28.0347 23.872 28.344 23.616 28.6C23.36 28.8667 23.0453 29 22.672 29H9.328C8.96533 29 8.65067 28.8667 8.384 28.6C8.128 28.344 8 28.0347 8 27.672V14.328C8 13.9547 8.128 13.64 8.384 13.384C8.65067 13.128 8.96533 13 9.328 13H16V13.992H9.328C9.24267 13.992 9.168 14.0293 9.104 14.104C9.04 14.168 9.008 14.2427 9.008 14.328V27.672C9.008 27.7573 9.04 27.832 9.104 27.896C9.168 27.9707 9.24267 28.008 9.328 28.008H22.672C22.7573 28.008 22.832 27.9707 22.896 27.896C22.9707 27.832 23.008 27.7573 23.008 27.672V21ZM14.704 22.968L14 22.28L22.304 13.992H18.656C18.5173 13.992 18.4 13.944 18.304 13.848C18.208 13.752 18.16 13.6347 18.16 13.496C18.16 13.3573 18.208 13.24 18.304 13.144C18.4 13.048 18.5173 13 18.656 13H23.984V18.328C23.984 18.4667 23.936 18.584 23.84 18.68C23.744 18.776 23.6267 18.824 23.488 18.824C23.3493 18.824 23.232 18.776 23.136 18.68C23.04 18.584 22.992 18.4667 22.992 18.328V14.68L14.704 22.968Z" fill="#415385" />
                </svg>
              </div>
            </div>
            <p className="small-text-money">Get action paths and coaching tips tailored to your goals.</p>
          </div>}
          {!_.isEmpty(moneyJourney) && moneyJourney?.coach?.status !== "completed" && 
          <div className="card-money" tabIndex="0" aria-label="Take the tour. Learn where everything is so you can start digging into the content.">
              <div class="d-flex align-items-center justify-content-between gap-10 titlt-headmoney">
              <div className="icon-left">
                <span className='money-journey'>
                   <svg width="30" height="48" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 25.5C13.5 25.5 12.12 25.13 10.86 24.39C9.60001 23.63 8.60001 22.62 7.86 21.36C7.12001 20.1 6.75 18.73 6.75 17.25C6.75 15.75 7.12001 14.37 7.86 13.11C8.60001 11.85 9.60001 10.85 10.86 10.11C12.12 9.37 13.5 9 15 9C16.5 9 17.88 9.37 19.14 10.11C20.4 10.85 21.4 11.85 22.14 13.11C22.88 14.37 23.25 15.75 23.25 17.25C23.25 18.75 22.88 20.13 22.14 21.39C21.4 22.65 20.4 23.65 19.14 24.39C17.88 25.13 16.5 25.5 15 25.5ZM15 10.83C13.84 10.83 12.77 11.12 11.79 11.7C10.81 12.28 10.03 13.06 9.45001 14.04C8.89001 15.02 8.61001 16.09 8.61001 17.25C8.61001 18.41 8.89001 19.48 9.45001 20.46C10.03 21.44 10.81 22.22 11.79 22.8C12.77 23.36 13.84 23.64 15 23.64C16.16 23.64 17.23 23.36 18.21 22.8C19.19 22.22 19.96 21.44 20.52 20.46C21.1 19.48 21.39 18.41 21.39 17.25C21.39 16.09 21.1 15.02 20.52 14.04C19.96 13.06 19.19 12.28 18.21 11.7C17.23 11.12 16.16 10.83 15 10.83ZM27.3 29.16C27.46 29.24 27.59 29.36 27.69 29.52C27.81 29.66 27.87 29.82 27.87 30V38.07C27.87 38.33 27.78 38.55 27.6 38.73C27.42 38.91 27.2 39 26.94 39H3.06C2.8 39 2.58 38.91 2.4 38.73C2.22 38.55 2.13 38.33 2.13 38.07V30C2.13 29.82 2.18 29.66 2.28 29.52C2.38 29.36 2.52 29.24 2.7 29.16C5.08 28.12 7.74001 27.41 10.68 27.03C13.56 26.67 16.44 26.67 19.32 27.03C22.26 27.41 24.92 28.12 27.3 29.16ZM15 30.9L14.04 34.17L14.94 35.1L15.96 34.14L15 30.9ZM26.01 37.17V30.63C23.37 29.59 20.62 28.96 17.76 28.74L16.14 29.28L17.97 34.26C18.05 34.48 18.04 34.7 17.94 34.92C17.86 35.14 17.72 35.3 17.52 35.4L14.88 37.38L12.42 35.37C12.22 35.27 12.08 35.11 12 34.89C11.94 34.69 11.95 34.48 12.03 34.26L13.86 29.28L12.24 28.74C9.38 28.96 6.63 29.59 3.99 30.63V37.17H26.01Z" fill="#474747" />
                </svg>
                </span>
                <h3 className="card-money-title ps-0 mb-0">Schedule a coaching session</h3>
              </div>
              <div class="linkicon" onClick={() => { callScheduleApi(); window.open(moneyJourney?.coach?.coach_url, "_blank")}}>
                <svg width="32" height="48" viewBox="0 0 32 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.008 21H24V27.672C24 28.0347 23.872 28.344 23.616 28.6C23.36 28.8667 23.0453 29 22.672 29H9.328C8.96533 29 8.65067 28.8667 8.384 28.6C8.128 28.344 8 28.0347 8 27.672V14.328C8 13.9547 8.128 13.64 8.384 13.384C8.65067 13.128 8.96533 13 9.328 13H16V13.992H9.328C9.24267 13.992 9.168 14.0293 9.104 14.104C9.04 14.168 9.008 14.2427 9.008 14.328V27.672C9.008 27.7573 9.04 27.832 9.104 27.896C9.168 27.9707 9.24267 28.008 9.328 28.008H22.672C22.7573 28.008 22.832 27.9707 22.896 27.896C22.9707 27.832 23.008 27.7573 23.008 27.672V21ZM14.704 22.968L14 22.28L22.304 13.992H18.656C18.5173 13.992 18.4 13.944 18.304 13.848C18.208 13.752 18.16 13.6347 18.16 13.496C18.16 13.3573 18.208 13.24 18.304 13.144C18.4 13.048 18.5173 13 18.656 13H23.984V18.328C23.984 18.4667 23.936 18.584 23.84 18.68C23.744 18.776 23.6267 18.824 23.488 18.824C23.3493 18.824 23.232 18.776 23.136 18.68C23.04 18.584 22.992 18.4667 22.992 18.328V14.68L14.704 22.968Z" fill="#415385" />
                </svg>
              </div>
            </div>
            <p className="small-text-money">Get financial coaching and ignite your path to financial wellness.</p>
          </div>}
          {!_.isEmpty(moneyJourney) && moneyJourney?.action_path?.status !== "completed" && <div className="card-money" tabIndex="0" aria-label="Take the tour. Learn where everything is so you can start digging into the content.">
               <div class="d-flex align-items-center justify-content-between gap-10 titlt-headmoney">
              <div className="icon-left">
                <span className='money-journey'>
                  <svg width="30" height="48" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.91005 10.95L8.94005 10.92C9.18005 10.92 9.38005 10.84 9.54005 10.68C9.66005 10.56 9.74005 10.41 9.78005 10.23C9.82005 10.05 9.80005 9.89 9.72005 9.75C9.66005 9.59 9.55005 9.46 9.39005 9.36C9.25005 9.26 9.10005 9.21 8.94005 9.21L2.61005 9.15L2.55005 15.66C2.55005 15.9 2.63005 16.11 2.79005 16.29C2.97005 16.45 3.18005 16.53 3.42005 16.53C3.66005 16.53 3.86005 16.45 4.02005 16.29C4.20005 16.11 4.29005 15.9 4.29005 15.66L4.38005 12.09L13.59 21.27L14.34 22.08V39H16.23V21.3L5.91005 10.95ZM27.3901 9L21.09 9.03C20.85 9.03 20.64 9.12 20.46 9.3C20.3 9.46 20.21 9.66 20.19 9.9C20.17 10.14 20.26 10.34 20.46 10.5C20.62 10.68 20.82 10.77 21.06 10.77L24.0901 10.8L16.62 18.24L17.97 19.56L25.59 11.91L25.71 15.51C25.71 15.75 25.8 15.96 25.98 16.14C26.16 16.3 26.3601 16.38 26.58 16.38C26.84 16.38 27.05 16.3 27.21 16.14C27.3701 15.96 27.4501 15.75 27.4501 15.51L27.3901 9Z" fill="#474747" />
                </svg>
                </span>
                <h3 className="card-money-title ps-0 mb-0">Start your first action path</h3>
              </div>
              <div class="linkicon" onClick={() => {goToLPDetailUtil(moneyJourney?.action_path, navigate, 1)}}>
                <svg width="32" height="48" viewBox="0 0 32 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.008 21H24V27.672C24 28.0347 23.872 28.344 23.616 28.6C23.36 28.8667 23.0453 29 22.672 29H9.328C8.96533 29 8.65067 28.8667 8.384 28.6C8.128 28.344 8 28.0347 8 27.672V14.328C8 13.9547 8.128 13.64 8.384 13.384C8.65067 13.128 8.96533 13 9.328 13H16V13.992H9.328C9.24267 13.992 9.168 14.0293 9.104 14.104C9.04 14.168 9.008 14.2427 9.008 14.328V27.672C9.008 27.7573 9.04 27.832 9.104 27.896C9.168 27.9707 9.24267 28.008 9.328 28.008H22.672C22.7573 28.008 22.832 27.9707 22.896 27.896C22.9707 27.832 23.008 27.7573 23.008 27.672V21ZM14.704 22.968L14 22.28L22.304 13.992H18.656C18.5173 13.992 18.4 13.944 18.304 13.848C18.208 13.752 18.16 13.6347 18.16 13.496C18.16 13.3573 18.208 13.24 18.304 13.144C18.4 13.048 18.5173 13 18.656 13H23.984V18.328C23.984 18.4667 23.936 18.584 23.84 18.68C23.744 18.776 23.6267 18.824 23.488 18.824C23.3493 18.824 23.232 18.776 23.136 18.68C23.04 18.584 22.992 18.4667 22.992 18.328V14.68L14.704 22.968Z" fill="#415385" />
                </svg>
              </div>
            </div>
            <p className="small-text-money">Kick off your first action path and ignite your journey to financial wellness.</p>
          </div>} */}
            </Slider>
          </section>
          <SimplePopup
            confirmModal={showLimitPopup}
            setConfirmModal={setShowLimitPopup}
            showModalMsg={"Session request sent successfully"}
            isRightIcon={true}
          />
        </>
      )}
    </>
  );
};

export default MoneyJourney;
